import { IShowCheckUsersParams } from "src/models";
import CheckUsers from "src/components/CheckUsers/CheckUsers";

export default {
    checkUsersComponent: null,

    dispose() {
        if (this.checkUsersComponent) {
            this.checkUsersComponent.dispose();
        }
        this.checkUsersComponent = null;
    },

    show(params: IShowCheckUsersParams) {
        if (!this.checkUsersComponent) {
            this.checkUsersComponent = new CheckUsers({
                source: '<x-check-users></x-check-users>'
            });
            this.checkUsersComponent.attach(document.body);
        }
        this.checkUsersComponent.show(params)
    }
};
